import React from 'react'
import { Redirect, Route } from 'react-router-dom'
import useAuth from 'utils/authHook'
import { useStore } from 'store/GlobalContext'
import Login from 'components/pages/Login'
import KidRouter from 'components/pages/kids/Router'
import ParentRouter from 'components/pages/parents/ParentRouter'

const AppRouter = () => {
  const [{ loggedIn }] = useStore()
  const { logout } = useAuth()

  return (
    <>
      <Route path="/" exact>
        {loggedIn ? <Redirect to="/kids" /> : <Login />}
      </Route>

      <Route path="/login" exact>
        <Login />
      </Route>

      <Route path="/logout" render={() => logout()} />

      <Route
        path="/kids"
        render={({ location }) =>
          loggedIn ? (
            <KidRouter />
          ) : (
            <Redirect to={{ pathname: '/login', state: { from: location } }} />
          )
        }
      />

      <Route
        path="/parents"
        render={({ location }) =>
          loggedIn ? (
            <ParentRouter />
          ) : (
            <Redirect to={{ pathname: '/login', state: { from: location } }} />
          )
        }
      />
    </>
  )
}

export default AppRouter
